module.exports = __webpack_public_path__ + "assets/img/report-info-bg.b7833df2.png";